import React from 'react';
import { useField } from 'formik';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface IProps {
  name: string
  label: string
  disabled?: boolean
}

const XCheckBoxInput = (props: IProps) => {
  const { name, label, disabled } = props;
  const [field] = useField({ name });

  return (
    <FormControlLabel
      label={label}
      control={(
        <Checkbox
          checked={Boolean(field.value)}
          value={Boolean(field.value)}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={name}
          color="primary"
        />
          )}
      disabled={disabled ?? false}
    />
  );
};
export default XCheckBoxInput;
